import { useEffect, useState } from 'react';
import clienteAxios from '../../../configAxios/configAxios';


const useServicios = (servicios, zona, region) => {
    const [concesionarios, setConcesionarios] = useState([])
    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState(false);

    const fetchConcesionariosFiltro = async () => {

        let zonaF = zona === undefined ? "" : zona;
        let regionF = region === undefined ? "" : region.toString();
        let repuestos = "";
        let servicio = "";
        //eslint-disable-next-line
        servicios.map(nombreServicio => {
            if (nombreServicio === "repuestos") {
                repuestos = "repuestos";
            }
            else if (nombreServicio === "servicio") {
                servicio = "servicio";
            }
        });
        try {
            let data = { venta: "", repuestos, servicio, zona: zonaF, region: regionF };

            let response = await clienteAxios.post('filtrarOficinas', data);

            if (response.status === 200) {
                let datos = response.data.data;
                let concesionarios = Object.keys(datos).map(x => datos[x]);
                setConcesionarios(concesionarios);
                return;
            }
            setError(true);

        } catch (error) {
            setError(true);
            setIsloading(false);
        }

    }

    useEffect(() => {
        fetchConcesionariosFiltro();
        //eslint-disable-next-line
    }, [servicios, zona, region])


    return [concesionarios, isLoading, error];
}

export const useGarantia = (idCategoria) => {
    const [vehiculos, setVehiculos] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {

        const fetchVehiculosServicioTecnico = async () => {
            try {
                let response = await clienteAxios.get(`servicioTecnicoPorCategoria/${idCategoria}`);

                if (response.status === 200) {
                    let data = response.data.data;

                    setVehiculos(data);
                    return
                }

                setError(true);
            } catch (error) {
                setError(true);
            }
        }
        fetchVehiculosServicioTecnico();
    }, [idCategoria])

    return [vehiculos, error];
}

export const useSliderServicio = () => {
    const [sliders, setSliders] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        const getSliders = async () => {
            try {
                let response = await clienteAxios.get('sliders/modulo/SERV_TECNICO');
                if (response.status === 200) {
                    let data = response.data.data;
                    if (data && Array.isArray(data) && data.length > 0) {
                        let slider = data.filter(s => s.Seccion !== 'PROMOCIONAL')
                        setSliders(slider.sort((a, b) => a.Orden - b.Orden));
                        setLoading(false);
                    }
                    else {
                        setError(true);
                        setLoading(false);
                    }
                }
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
        getSliders();

    }, [])

    return { sliders, loading, error };
}

export const useCondiciones = () => {
    const [condiciones, setCondiciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        const getCondiciones = async () => {
            try {
                let response = await clienteAxios.get('Parametro/modulo/SERV_TECNICO');
                if (response.status === 200) {
                    let data = response.data.data;
                    if (data && Array.isArray(data) && data.length > 0) {
                        let condicion = data.filter(c => c.Etiqueta === 'CONDICIONES' && c.Estado === 'A')
                        setCondiciones(condicion);
                        setLoading(false);
                    }
                    else {
                        setError(true);
                        setLoading(false);
                    }
                }
            } catch (error) {
                setError(true);
                setLoading(false);
            }
        }
        getCondiciones();

    }, [])

    return [ condiciones, loading, error ];
}
export default useServicios;